import styled from "styled-components";

export const CreateAccountContainer = styled.form`
  margin: 0% 2% 2% 2%;
`